module.exports = __webpack_public_path__ + "assets/img/image.88e53b89.svg";